import { render, staticRenderFns } from "./cover-field.vue?vue&type=template&id=7d96d948&scoped=true"
import script from "./cover-field.vue?vue&type=script&lang=js"
export * from "./cover-field.vue?vue&type=script&lang=js"
import style0 from "./cover-field.vue?vue&type=style&index=0&id=7d96d948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d96d948",
  null
  
)

export default component.exports